/* eslint-disable react/jsx-no-bind */
import React, { useEffect } from 'react';
import Loading from '@ifit/mp-loading';

import {
  useSeriesRowInfiniteQuery,
  useSeriesRowByCategoryInfiniteQuery,
} from '../../../client/query/series';
import GridSection from '../../../components/grid-section';
import InfiniteScrollRQ from '../../../components/infinite-scroll-rq';
import { getSearchState } from '../../search/state/search-state';
import { ILibraryContentItemType } from '@ifit/gateway-wolf-athenaeum-service/models/library-content-item-type';
import flatten from 'lodash.flatten';
import { InfiniteQueryObserverResult } from 'react-query';
import { useParams } from 'react-router-dom';
import { ProgramsParams } from '../../routes';
import { setToolbarTitle } from '../../../store/to-native';
import { categorySeriesTitle } from '../../../i18n/translations';
import { useGetFilterOptions } from '../../../client/query/filter-options';

const ProgramsList = ({
  data,
  fetchNextPage,
  isFetching,
  isLoading,
  isError,
}): JSX.Element => {
  function fetch(): Promise<InfiniteQueryObserverResult> {
    return fetchNextPage();
  }
  if (!data && isLoading) {
    return <Loading absolute />;
  }

  const { pages } = data;
  const hasMoreItems = pages.length && pages[pages.length - 1].hasMoreItems;
  const series = flatten(pages.map(p => p.data));

  return (
    <div className="programs-category-view">
      {series[0] && (
        <InfiniteScrollRQ
          libraryCards={series}
          loadMore={fetch}
          hasMoreItems={hasMoreItems}
          isFetching={isFetching}
          isError={isError}
        >
          <GridSection />
        </InfiniteScrollRQ>
      )}
    </div>
  );
};

const ProgramsByCategory = (): JSX.Element => {
  const props = useSeriesRowByCategoryInfiniteQuery();

  return <ProgramsList {...props} />;
};

const ProgramsWithoutCategory = (): JSX.Element => {
  const props = useSeriesRowInfiniteQuery();

  return <ProgramsList {...props} />;
};

const Programs = (): JSX.Element => {
  const { categorySlug } = useParams<ProgramsParams>();
  const { data: filterOptions } = useGetFilterOptions();

  useEffect(() => {
    getSearchState().setViewContext({
      includedEntities: [ILibraryContentItemType.Program],
      categories: [categorySlug].filter(Boolean),
    });

    if (categorySlug !== undefined) {
      const category = filterOptions?.categoryOptions?.find(
        cat => cat.value === categorySlug,
      );
      setToolbarTitle(categorySeriesTitle(category?.display));
    }
  }, [categorySlug, filterOptions]);
  if (categorySlug !== undefined) {
    return <ProgramsByCategory />;
  }

  return <ProgramsWithoutCategory />;
};

export default Programs;
